import { ModalOptions } from '@epicuro-next/ataraxia/modal';
import { createAction, props } from '@ngrx/store';

export const openDropShipModal = createAction(
  '[Basket Modals] Open Drop Ship',
  props<{ options?: Partial<ModalOptions> }>(),
);

export const closeDropShipModal = createAction(
  '[Basket Modals] Close Drop Ship',
);

export const makePendingDropShipModal = createAction(
  '[Basket Modals] Make Pending Drop Ship',
);

export const openRequestReviewerModal = createAction(
  '[Basket Modals] Open Request Order Reviewer',
  props<{ options?: Partial<ModalOptions> }>(),
);

export const closeRequestReviewerModal = createAction(
  '[Basket Modals] Close Request Order Reviewer',
);

export const makePendingRequestReviewerModal = createAction(
  '[Basket Modals] Make Pending Request Order Reviewer',
);

export const openRejectReviewerModal = createAction(
  '[Basket Modals] Open Reject Order Reviewer',
  props<{ options?: Partial<ModalOptions> }>(),
);

export const closeRejectReviewerModal = createAction(
  '[Basket Modals] Close Reject Order Reviewer',
);

export const makePendingRejectReviewerModal = createAction(
  '[Basket Modals] Make Pending Reject Order Reviewer',
);

export const triggerOpenCopyProductsModal = createAction(
  '[Basket Modals] Trigger Open Copy Products',
  props<{
    uniqueAddressLineId: string;
  }>(),
);

export const openCopyProductsModal = createAction(
  '[Basket Modals] Open Copy Products',
  props<{
    uniqueAddressLineId: string;
    options?: Partial<ModalOptions>;
  }>(),
);

export const closeCopyProductsModal = createAction(
  '[Basket Modals] Close Copy Products',
);
